import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity UserSessions


export interface UserSession {
    id: ID;

    
    userId: ID;

    
    userGroupId: ID;

    
    refreshToken: string;

    
    device?: string;

    
    createdAt: Date;

    
    updatedAt: Date;

    }

export interface FilterUserRequest {
    list: ListRequest,
    filter: {
        
            userId?: ID,
        
    
    



        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}
export interface FilterRefreshTokenRequest {
    list: ListRequest,
    filter: {
        
            refreshToken?: string,
        
    
    



        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateUserSession {
    
    userId: ID;

    
    userGroupId: ID;

    
    refreshToken: string;

    
    device?: string;

    
    
    }


export interface UpdateUserSession {
    
    
    
    refreshToken: string;

    
    device?: string;

    
    
    }

export interface PresentationUserSessionRequest {
    list: ListRequest,
    filter: {
        userId: ID,
        userIdOr: boolean,
        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryUserSession {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: UserSession): PrimaryUserSession | undefined {
        return entity ? new PrimaryUserSession(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryUserSession {
        return new PrimaryUserSession(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryUserSession {
        let vals = path?.split('/');
        return new PrimaryUserSession(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryUserSession[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: UserSession): string {
    let fields = entity ? [
    entity.userId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityUserSession {
    id: PrimaryUserSession;
    data: UpdateUserSession;


    constructor(id: PrimaryUserSession, data: UpdateUserSession) {
        this.id = id;
        this.data = data;
    }
}
